<template>
  <div>
    <AlertComponent />
    <LoadingComponent />
    <ImageViewerComponanet />
    <div id="app" v-if="$store.state.Auth.isAuth">
      <SidebarComponent />
      <div id="content">
        <HeaderComponent />
        <div class="ctn">
          <!-- <NavbarComponent /> -->
          <router-view />
        </div>
      </div>
    </div>
    <div id="app" v-if="!$store.state.Auth.isAuth">
      <router-view />
    </div>
  </div>
</template>
<script>
import AlertComponent from "./components/AlertComponent.vue";
import LoadingComponent from "./components/LoadingComponent.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import SidebarComponent from "./components/SidebarComponent.vue";
import ImageViewerComponanet from "./components/images/ImageViewerComponanet.vue";
// import NavbarComponent from "./components/NavbarComponent.vue";

export default {
  components: {
    SidebarComponent,
    HeaderComponent,
    LoadingComponent,
    AlertComponent,
    ImageViewerComponanet,
    // NavbarComponent,
  },
};
</script>
<style scoped>
@media (min-width: 768px) { 
  #content {
    position: relative;
    width: calc(100% - 240px);
    left: 240px;
    transition: all 0.3s ease;
  }

  #sidebar.hide + #content {
    width: calc(100% - 60px);
    left: 60px;
  }
}
@media (max-width: 767.98px) { 
  #content {
    position: relative;
    width: 100%; /* Default untuk layar kecil */
    left: 0;
    transition: all 0.3s ease;
  }

  #sidebar.hide + #content {
    width: 100%; /* Konten tetap penuh jika sidebar disembunyikan */
    left: 0;
  }

  #sidebar {
    width: 100%; /* Sidebar default full-width */
    transition: all 0.3s ease;
  }

  #sidebar.hide {
    width: 0; /* Sidebar disembunyikan */
    overflow: hidden; /* Sembunyikan konten sidebar */
  }
}

/* STYLE MOBILE DEVICE  */
</style>
